import ActualizarHorariosNavieros from "./ActualizarHorariosTerrestres";
export default ActualizarHorariosNavieros;